import { useState } from 'react';
import OS_Page from "./components/OS_Page";
import BootSequence from "./components/BootSequence";
import SplashScreen from "./components/SplashScreen";

// Flow: boot → splash → os
function App() {
  const [phase, setPhase] = useState('boot');

  return (
    <div className="App">
      {phase === 'boot'   && <BootSequence  onComplete={() => setPhase('splash')} />}
      {phase === 'splash' && <SplashScreen  onComplete={() => setPhase('os')} />}
      {phase === 'os'     && <OS_Page />}
    </div>
  );
}

export default App;
